/**
 * Les quatre familles de competences, et les outils qui les composent.
 *
 * Une seule source : la galerie en profondeur affiche les cartes, et les
 * pastilles qui flottent autour sont exactement les memes outils, aplatis.
 * Rien a resynchroniser a la main.
 */

export interface Competence {
  titre: string;
  /** Nom du fichier dans /public/competences, sans la taille ni l'extension. */
  image: string;
  outils: string[];
}

export const COMPETENCES: Competence[] = [
  {
    titre: "Backend et données",
    image: "backend",
    outils: ["Python", "Django", "Django REST", "PostgreSQL", "Celery", "Redis"],
  },
  {
    titre: "Interfaces",
    image: "frontend",
    outils: ["React", "TypeScript", "Tailwind", "Vite", "Accessibilité"],
  },
  {
    titre: "IA et automatisation",
    image: "ia",
    outils: ["Agents", "Extraction de données", "API d'IA", "Traitement par lots"],
  },
  {
    titre: "Mise en production",
    image: "devops",
    outils: ["Railway", "Vercel", "Git", "CI/CD", "Rendu serveur", "Performance"],
  },
];

export const OUTILS = COMPETENCES.flatMap((c) => c.outils);
